export const inputSvc = (
  value,
  onChange,
  changeCallback,
  service,
  options = {}
) => {
  const { maxDigits } = options;

  const services = {
    removeText: () => {
      let newValue = value.replace(/\D/g, "");
      if (maxDigits) {
        newValue = newValue.slice(0, maxDigits);
      }
      changeCallback && changeCallback(newValue);
      onChange(newValue);
    },

    removeOuterText: () => {
      let newValue = value.replace(/^[^\d]+/, "");
      newValue = newValue.replace(/(\d)([^\d]+)(\d)/g, "$1$2$3");
      if (maxDigits) {
        newValue = newValue.slice(0, maxDigits);
      }
      changeCallback && changeCallback(newValue);
      onChange(newValue);
    },

    removeSpaces: () => {
      let newValue = value.trim();
      changeCallback && changeCallback(newValue);
      onChange(newValue);
    },

    formatNumber: () => {
      let rawValue = value.replace(/[^0-9.]/g, "");

      const [integerPart, ...decimalParts] = rawValue.split(".");
      const decimalPart = decimalParts.join("").slice(0, 2);

      const formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      const formattedValue =
        decimalParts.length > 0 ? `${formatted}.${decimalPart}` : formatted;

      changeCallback && changeCallback(formattedValue);
      onChange(formattedValue);
    },

    removeNumbers: () => {
      let newValue = value.replace(/\d/g, "");
      if (maxDigits) {
        newValue = newValue.slice(0, maxDigits);
      }
      changeCallback && changeCallback(newValue);
      onChange(newValue);
    },

    default: () => {
      changeCallback && changeCallback(value);
      onChange(value);
    },
  };

  const handler = services[service] || services.default;
  handler();
};
